export default __webpack_public_path__ + "static/media/e-ppt-logotype-l.393ed258.svg";